import bus from "@/assets/images/bus.webp";
import earth from "@/assets/images/earth.png";
import React from "react";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";

interface Props {
  embedded?: boolean;
  small?: boolean;
  label?: string;
}

export default function LoadingSpinner(props: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={` ${
        props.embedded
          ? "loading-spinner-container-embedded"
          : "loading-spinner-container"
      } ${props.small ? "small" : ""} `}
      aria-busy="true"
    >
      <div className="loading-spinner-main">
        <Image
          src={earth}
          alt={t("LOADING.IMGALT.EARTH")}
          width={50}
          height={50}
        />
        <div className="loading-spinner">
          <Image
            src={bus}
            alt={t("LOADING.IMGALT.BUS")}
            width={10}
            height={10}
          />
        </div>
      </div>
      {props.label && (
        <div className="loading-spinner-label">{props.label}</div>
      )}
    </div>
  );
}
